@if (loading()) {
  <p class="loading-hint">Cargando datos…</p>
} @else {
  <mat-card class="active-enrollment-card">
    <mat-card-content>
      <h3 class="active-enrollment-card__title">Formaciones activas</h3>
      @if (active_enrollments().length > 0) {
        <ul class="active-enrollments-list">
          @for (enrollment of active_enrollments(); track enrollment.id) {
            <li class="active-enrollment-summary">
              <div class="active-enrollment-summary__details">
                <strong>{{ enrollment.learning_resource?.name ?? '—' }}</strong>
                <span class="muted">desde {{ enrollment.start_date | date: 'dd/MM/yyyy' }}</span>
              </div>
              <button
                mat-stroked-button
                type="button"
                color="accent"
                class="complete-active-enrollment-button"
                (click)="completeActiveEnrollment(enrollment)"
              >
                <mat-icon>check_circle</mat-icon>
                Marcar como completada
              </button>
            </li>
          }
        </ul>
      } @else {
        <p class="muted">Sin formaciones activas.</p>
      }
    </mat-card-content>
  </mat-card>

  <section>
    <h3>Historial de matrículas</h3>
    <div class="bisual-table-container">
      <table mat-table [dataSource]="enrollments_data_source">
        <ng-container matColumnDef="resource">
          <th mat-header-cell *matHeaderCellDef>Formación</th>
          <td mat-cell *matCellDef="let element">{{ element.resource_name }}</td>
        </ng-container>

        <ng-container matColumnDef="period">
          <th mat-header-cell *matHeaderCellDef>Periodo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.start_date | date: 'dd/MM/yyyy' }}
            –
            @if (element.end_date) {
              {{ element.end_date | date: 'dd/MM/yyyy' }}
            } @else {
              actualidad
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="hours">
          <th mat-header-cell *matHeaderCellDef>Horas imputadas</th>
          <td mat-cell *matCellDef="let element">{{ element.formation_hours_label }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let element">
            {{ element.is_active ? 'Activa' : 'Cerrada' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="enrollments_displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: enrollments_displayed_columns"></tr>
      </table>
    </div>
  </section>

  <section>
    <h3>Cursos completados</h3>
    <div class="bisual-table-container">
      <table mat-table [dataSource]="achievements_data_source">
        <ng-container matColumnDef="resource">
          <th mat-header-cell *matHeaderCellDef>Formación</th>
          <td mat-cell *matCellDef="let element">{{ element.learning_resource?.name ?? '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="period">
          <th mat-header-cell *matHeaderCellDef>Periodo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.start_date | date: 'dd/MM/yyyy' }}
            @if (element.end_date) {
              – {{ element.end_date | date: 'dd/MM/yyyy' }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="completed_ago">
          <th mat-header-cell *matHeaderCellDef>Completado hace</th>
          <td mat-cell *matCellDef="let element">{{ element.end_date ?? element.start_date | completedAgo }}</td>
        </ng-container>

        @if (enable_achievement_management()) {
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="actions-cell">
              <div class="table-actions">
                <button mat-icon-button type="button" matTooltip="Editar" (click)="openEditAchievementDialog(element)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button type="button" matTooltip="Eliminar" (click)="deleteAchievement(element)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="achievements_displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: achievements_displayed_columns"></tr>
      </table>

      @if (achievements_data_source.data.length === 0) {
        <p class="muted empty-hint">Sin cursos completados registrados.</p>
      }
    </div>
  </section>
}
